// Admin password hash - set to AdminPass123! for now
const ADMIN_PASSWORD_HASH = 'QWRtaW5QYXNzMTIzIQ==';

export const validateAdminPassword = (password: string): boolean => {
  // Simple hash for demo - you should use bcrypt in production
  const hash = btoa(password); // Base64 encoding
  return hash === ADMIN_PASSWORD_HASH;
};
